import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import { makeStyles } from '@mui/styles'
import React, { useState } from 'react'

import { PurchaseOption } from '../../typings/Product'

import ProductInformationDialog from './ProductInformationDialog'

interface Props {
  product: PurchaseOption
}

const useStyles = makeStyles({
  icon: {
    cursor: 'pointer',
    alignSelf: 'flex-start',
  },
})

const ProductInformation: React.FC<React.PropsWithChildren<Props>> = ({ product }) => {
  const classes = useStyles()
  const [showProductInformation, setShowProductInformation] = useState(false)

  const handleClick = () => {
    setShowProductInformation(!showProductInformation)
  }

  const handleClose = () => {
    setShowProductInformation(false)
  }

  return (
    <>
      <Icon icon={Icons.INFO} size="large" color="primary.main" className={classes.icon} onClick={handleClick} />
      <ProductInformationDialog product={product} isOpen={showProductInformation} onClose={handleClose} />
    </>
  )
}

export default ProductInformation
